import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router'
import { environment } from '../../environments/environment';

@Component({
    selector: 'app-dashboard',
    templateUrl: './full-layout.component.html'
})
export class FullLayoutComponent implements OnInit {

    username: string;
    kairos:boolean = false;    

    constructor(private authService: AuthService, private router: Router) { 
        this.kairos = environment.kairos;
    }

    ngOnInit(): void {
        this.username = this.authService.username;        
    }

    logout() {
        this.authService.logout();
        this.router.navigate(['login']);
    }
}



// WEBPACK FOOTER //
// C:/Source/eSoftCereal.API/eSoftCereal.UI/src/app/layouts/full-layout.component.ts